<template>
  <div class="student-exercise-container">
    <div class="banner">
      <div class="banner-img">
        <img src="@/assets/images/banner/banner_8.png"  alt="">
      </div>
    </div>
    <div class="content">
      <div class="left-container">
        <a href="javascript:;" class="item" :class="{active:index===navIndex}" v-for="(item,index) in navData" :key="index" @click="onSelectNav(index,item.path)">
          <span>{{item.name}}</span>
          <img src="@/assets/images/1.png" class="icon" alt="" v-show="index===navIndex">
        </a>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
  
  // import md5 from 'js-md5';
  export default {
    components: {
      
    },
    data() {
      return {
        navData:[
          {'id':1,name:'智慧学', path:'/student/zihuixue'},
          {'id':2,name:'错题本', path:'/student/errorbooks'},
          {'id':3,name:'作业册', path:'/student/books'},
        ],
        navIndex:0
      }
    },
    created() {
      this.path = this.$route.path;
      // console.log(this.path)
      this.navIndex = this.navData.findIndex(item => item.path === this.path )

    },
    methods: {
      onSelectNav(i,path){
        if(this.navIndex === i){
          return false;
        }
        this.navIndex = i;
        this.$router.push(path);
      }
    }
  }
</script>
<style scoped>
  @import '../../assets/css/student.css';
</style>